import React, { useState } from "react";
import "./NewHeader.scss";
import { AllImages } from "../Assets/Images/AllImages";

const NewHeader = () => {
  const [showMenu, setShowMenu] = useState(true);

  const handleMenuIconClick = () => {
    setShowMenu(!showMenu);
  };
  return (
    <div className="new-header-container">
      <div className="left-content">
        <div className="logo">
          <a href="/#">Rohan Nagar</a>
        </div>
        <div className="bar-icon" onClick={() => handleMenuIconClick()}>
          <img src={AllImages.MenuIcon} alt="" />
        </div>
      </div>

      <div className={`right-content ${showMenu === true ? "" : "d-none"}`}>
        <div className="link">
          <a href="#about">About</a>
        </div>
        <div className="link">
          <a href="#skills">Skills</a>
        </div>
        <div className="link">
          <a href="#experience">Experience</a>
        </div>
        <div className="link">
          <a href="#projects">Projects</a>
        </div>
        <div className="link">
          <a href="#contact">Contact</a>
        </div>
      </div>
    </div>
  );
};

export default NewHeader;
